import { isEmpty } from 'lodash'

/**
 * 接口缓存
 * @param api 接口
 * @param pageCacheKey 页面缓存key
 * @param apiKeyFun  Function 接口key或者从参数获取key
 * @param isCache 是否开启缓存
 * @returns {Promise<unknown>|*}
 */
function apiCacheHandle(api, pageCacheKey, apiKeyFun, isCache, that) {
  return new Proxy(api, {
    apply(target, thisArg, argArray) {
      if (isCache) {
        const apiKey = apiKeyFun(argArray)
        return that.$store.dispatch('GetCacheInfo', { pageKey: pageCacheKey, apiKey: apiKey }).then(cache => {
          if (!isEmpty(cache)) {
            return new Promise(resolve => {
              resolve(cache)
            })
          } else {
            return target(...argArray).then(res => {
              that.$store.commit('SET_CACHE_INFO', { pageKey: pageCacheKey, apiKey: apiKey, data: res })
              return new Promise(resolve => {
                resolve(res)
              })
            })
          }
        })
      } else {
        return target(...argArray)
      }
    }
  })
}
export default apiCacheHandle
